export * as common from './property.notes.common'
export * as list from './property.notes.list'